import { View } from "binder"
import { FormBuilderComponentView, FormBuilderElement } from "src/formBuilder/structure/element";
import { DummyPlaceHolderElement } from "./dummyPlaceHolder-viewModel"

export class DummyPlaceHolderView extends FormBuilderComponentView<DummyPlaceHolderElement>{
    GetViewUniqueId(): string {
        return "V-C67B9C85-D5E5-4DB8-802C-A0876EB9095C"
    }
    loadHtml(): string {
        let element = require('./dummyPlaceHolder.html').default;
        let style = require('./dummyPlaceHolder.less');
        return element;
    }
    constructor() {
       super();
    }

    public set Content(v: FormBuilderElement) { this._Content = v; } public get Content(): FormBuilderElement { return this._Content;} private _Content: FormBuilderElement;

}
